// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_p7NlT","subtitle":"index_subtitle_DPQSv","viptitle":"index_viptitle_nD7yo","box":"index_box_Dldkz","tips":"index_tips_J8Deb","btn":"index_btn_m-eNA"};